/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserReportControllerCreateMonthlyGenerationsSnapshot201ResponseData } from './userReportControllerCreateMonthlyGenerationsSnapshot201ResponseData';


export interface UserReportControllerCreateMonthlyGenerationsSnapshot201Response { 
    statusCode?: number;
    success?: boolean;
    message?: string;
    data?: UserReportControllerCreateMonthlyGenerationsSnapshot201ResponseData;
    error?: string;
}

